import { DialogButton, EpicIcons } from "@constellation-academy/epic-ui";
import { readInlineData, useFragment } from "react-relay";
import { useTranslation } from "@i18n/hooks";
import { type editAccountGroupsButton_AccountFragment$key } from "@relay/editAccountGroupsButton_AccountFragment.graphql";
import { ACCOUNT_FRAGMENT, ACCOUNT_GROUP_FRAGMENT } from "./edit-account-groups-button.graphql";
import { type EditAccountGroupsButtonProps } from "./edit-account-groups-button.types";
import { EditAccountGroupsForm } from "../edit-account-groups-form/edit-account-groups-form.component";

export const EditAccountGroupsButton = ({
	accountFragmentRef,
	accountGroupsFragmentsRef,
}: EditAccountGroupsButtonProps) => {
	const { t } = useTranslation("common");
	const accountFragment = useFragment<editAccountGroupsButton_AccountFragment$key>(
		ACCOUNT_FRAGMENT,
		accountFragmentRef,
	);

	const accountGroupFragments = accountGroupsFragmentsRef
		.map((e) => readInlineData(ACCOUNT_GROUP_FRAGMENT, e))
		.filter((x): x is NonNullable<typeof x> => x != null);

	return (
		<DialogButton
			buttonIcon={EpicIcons.PENCIL}
			dialogTitle={t("account.groups")}
			tooltip={t("account.groups")}
		>
			{() => (
				<EditAccountGroupsForm
					accountFragmentRef={accountFragment}
					accountGroupsFragmentsRef={accountGroupFragments}
				/>
			)}
		</DialogButton>
	);
};
